/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SHARED_STYLES } from '../css/shared-css.js';
import './chromedash-feature-row.js';
let ChromedashReportSpecMentor = class ChromedashReportSpecMentor extends LitElement {
    static get styles() {
        return [...SHARED_STYLES, css ``];
    }
    render() {
        return html `
      <sl-details summary="${this.mentor.email} has mentored:" open>
        <table>
          ${this.mentor.mentored_features.map(feature => html `
              <chromedash-feature-row
                .feature="${feature}"
              ></chromedash-feature-row>
            `)}
        </table>
      </sl-details>
    `;
    }
};
__decorate([
    property({ attribute: false })
], ChromedashReportSpecMentor.prototype, "mentor", void 0);
ChromedashReportSpecMentor = __decorate([
    customElement('chromedash-report-spec-mentor')
], ChromedashReportSpecMentor);
export { ChromedashReportSpecMentor };
